<wilson-activity-location-mismatch-indicator>
</wilson-activity-location-mismatch-indicator>

<button
  nz-button
  nzType="default"
  class="w-100 mt-2 fw-normal location-button"
  [disabled]="isDisabled"
  (click)="updateLocation.emit()"
>
  <div class="flex-content">
    <ng-content></ng-content>
  </div>
</button>
